import { Component, OnInit, signal } from '@angular/core';
import { SeoService } from './_core/_services/seo.service';
import { ModalCleanupService } from './_core/_services/modal-cleanup.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('swipfx');

  constructor(
    private readonly seoService: SeoService,
    private readonly modalCleanup: ModalCleanupService,
  ) {}

  ngOnInit(): void {
    this.seoService.init();
    this.modalCleanup.registerGlobalCleanup();
  }
}
